var TW = {

    init : function(){

        if(console && console.log){
            console.log('Startup TW');
        }

        this.attachSlide();
        this.attachArrowNavigation();

        window.TW = this; //hack

        return this;
    },

    attachSlide : function(){
        var homeTitle = $("#content");
        var slidesWrapper = $("#slides");
        var homeLink = $(".js-home-title__link");
        var closeButton = $("#close");
        var overlay = $("#overlay");

        homeLink.each(function(index, element){
            $(this).on("click", function(event){
                $(this).addClass("-visited");
                var fragId = $(this).attr("href");
                var trimmedFragId = fragId.substring(1, fragId.length);

                slidesWrapper.addClass("-is-active");
                closeButton.addClass("-is-active");
                $("HTML, BODY").addClass("-slides-shown");
                homeTitle.addClass("-is-hidden");
                $(".slide").removeClass("-selected");
                $("[id="+trimmedFragId+"]").addClass("-selected");

            });
        });

        closeButton.on("click", function(){
           $(this).removeClass("-is-active");
            homeTitle.removeClass("-is-hidden");
            slidesWrapper.removeClass("-is-active");
            $("HTML, BODY").removeClass("-slides-shown");
            $(".arrow.-up").removeClass("-shown");
            $(".slide").removeClass("-selected");
            overlay.removeClass("-moved");
            $(window).scrollTop(0);
        });

    },

    attachArrowNavigation : function(){
        //The resize function
        function resize() {
            var vheight = $(window).height();
            $('.slide').css({
                'height': vheight
            });
        };

        // The scroll-up function
        function scrollUp() {
            var vheight = $(window).height();
            $('HTML, BODY').animate({
                scrollTop: (Math.ceil($(window).scrollTop() / vheight)-1) * vheight
            }, 350);
        };

        // The scroll-down function
        function scrollDown() {
            var vheight = $(window).height();
            $('HTML, BODY').animate({
                scrollTop: (Math.floor($(window).scrollTop() / vheight)+1) * vheight
            }, 350);
        };

        resize();

        $('#arrow-down').click(function(event){
            scrollDown();
            event.preventDefault();
        });

        $('#arrow-up').click(function(event){
            scrollUp();
            event.preventDefault();
        });

        $('#arrow-start').click(function(event){
            scrollDown();
            $(this).attr('data-used', true);
            event.preventDefault();
        });

        $(window).resize(function(){
            resize();
        });

        $(window).scroll(function() {

            $('.arrow[data-used="false"]').attr('data-used', true);

            if($("BODY").hasClass("-slides-shown")){
                if($(window).scrollTop() > $(".slide:first").height() - 10) {
                    $(".arrow.-up").addClass("-shown");
                    $(".arrow.-down").addClass("-shown");
                }
                else{
                    $(".arrow.-up").removeClass("-shown");
                    $(".arrow.-down").removeClass("-shown");
                }
            }
        });
    }
};
$(function(){
    TW.init();
});


// WEBPACK FOOTER //
// ./source/js/main.js